export enum InterventionOperationType {
  NEW,
  APPROVE,
  REJECT,
  CLEAR,
}

export namespace InterventionOperationType {
  let elements = [
    InterventionOperationType.NEW,
    InterventionOperationType.APPROVE,
    InterventionOperationType.REJECT,
    InterventionOperationType.CLEAR,
  ];
  let alias = "com.bcdfx.model.InterventionOperationType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
